import {
    Box,
    CircularProgress
} from '@mui/material'

import { forwardRef } from 'react'

import Styles from './style'

export const Loader = forwardRef((props, ref) => {
    return (
        <Box sx={props.sx || Styles.root} ref={ref} className={(props.display ?? false) ? 'display-block' : 'hide'}>
            <Box sx={Styles.media}>
                {props.message || 'LOADING'}<br />
                <CircularProgress />
            </Box>
        </Box>
    )
})

Loader.displayName = 'Loader'

export default Loader